import { initializeApp } from 'firebase/app';
import { initializeFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyD-CfgvztO54iQOmBr7amL9mhWbaNzt1Tc",
  authDomain: "keel-group-operations.firebaseapp.com",
  databaseURL: "https://keel-group-operations-default-rtdb.firebaseio.com",
  projectId: "keel-group-operations",
  storageBucket: "keel-group-operations.firebasestorage.app",
  messagingSenderId: "610932703450",
  appId: "1:610932703450:web:5660c9c60976f902cf65e3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
// ignoreUndefinedProperties: by default Firestore throws "Unsupported field
// value: undefined" and rejects the ENTIRE write if any field is undefined.
// That made saves silently fail (the error was swallowed by saveToFirestore)
// — e.g. setting an employee to Inactive, or copying a week of shifts that had
// no routeId. Dropping undefined fields instead keeps those writes working.
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true
});
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;
